import { t } from 'i18next';

import { ErrorResponseErrorItemCodeSkyMapConnect } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeSkyMapConnect, string> => ({
  'skymap_connect:folder_already_activated': t('skymapConnect.folderAlreadyActivated', {
    ns: 'apiErrorCodes',
    defaultValue: 'Mappen är redan kopplad till SkyMap Connect.',
  }),
  'skymap_connect:folder_not_found': t('skymapConnect.folderNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Mappen är inte kopplad till SkyMap Connect.',
  }),
});
